<template>
    <div>
        <!-- 搜索 -->
        <el-row class="player-pool__search">
            <div class="item">
                <span>用户ID:</span>
                <el-input v-model="searchList.rid" placeholder="请输入用户ID" style="width: 200px;"></el-input>
            </div>
            <div class="item">
                <span>变动类型:</span>
                <el-select v-model="searchList.action" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in actionList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>开始时间:</span>
                <el-date-picker
                    v-model="searchList.startTime"
                    type="datetime"
                    placeholder="选择开始时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="timestamp"
                    @change="handleStartTimeChange">
                </el-date-picker>
            </div>
            <div class="item">
                <span>结束时间:</span>
                <el-date-picker
                    v-model="searchList.endTime"
                    type="datetime"
                    placeholder="选择结束时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="timestamp"
                    @change="handleEndTimeChange">
                </el-date-picker>
            </div>
            <el-button type="primary" @click="getPlayerPoolInfoLogList(1)">搜索</el-button>
        </el-row>

        <!-- 操作按钮 -->
        <el-row style="margin-bottom: 20px;">
            <el-button type="warning" @click="showResetDialog">重置个人奖池</el-button>
            <el-button type="info" @click="showUpdateDialog">更新个人奖池数值</el-button>
        </el-row>

        <!-- 表格 -->
        <el-row>
            <el-table border :data="playerPoolInfoLogList" style="width: 100%">
                <el-table-column prop="id" label="ID" align="center" >
                </el-table-column>
                <el-table-column prop="eventCode" label="事件码" align="center">
                </el-table-column>
                <el-table-column prop="channel" label="渠道" align="center">
                    <template slot-scope="scope">
                        {{channelList.find(item => item.value == scope.row.channel)?.name || scope.row.channel}}
                    </template>
                </el-table-column>
                <el-table-column prop="uid" label="用户UID" align="center">
                </el-table-column>
                <el-table-column prop="rid" label="用户ID" align="center">
                </el-table-column>
                <el-table-column prop="action" label="变动类型" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getActionTagType(scope.row.action)" size="small">
                            {{ getActionText(scope.row.action) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="changed" label="变动数" align="center">
                </el-table-column>
                <el-table-column prop="afterBalance" label="变动后余额" align="center">
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center">
                </el-table-column>
                <el-table-column prop="ctime" :formatter="formatTime" label="操作时间" align="center" width="150">
                </el-table-column>
            </el-table>
        </el-row>

        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit"
                @current-change="handleCurrentChange">
            </el-pagination>
        </el-row>

        <!-- 重置个人奖池 -->
        <el-dialog title="重置个人奖池" :visible.sync="resetDialogVisible" width="400px">
            <el-form :model="resetForm" :rules="resetRules" ref="resetForm" label-width="100px">
                <el-form-item label="用户ID" prop="rid">
                    <el-input-number v-model="resetForm.rid" :min="1" placeholder="请输入用户ID" style="width: 100%;"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="resetPlayerPool">确定</el-button>
            </div>
        </el-dialog>

        <!-- 更新个人奖池数值 -->
        <el-dialog title="更新个人奖池数值" :visible.sync="updateDialogVisible" width="500px">
            <el-form :model="updateForm" :rules="updateRules" ref="updateForm" label-width="120px">
                <el-form-item label="用户ID" prop="rid">
                    <el-input-number v-model="updateForm.rid" :min="1" placeholder="请输入用户ID" style="width: 100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="变动类型" prop="action">
                    <el-radio-group v-model="updateForm.action">
                        <el-radio :label="1">增加</el-radio>
                        <el-radio :label="2">减少</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="变动数值" prop="num">
                    <el-input-number v-model="updateForm.num" :min="1" placeholder="请输入变动数值" style="width: 100%;"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="updatePlayerPool">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'PlayerPoolInfoLog',
    data() {
        return {
            searchList: {
                rid: null,
                action: null,
                startTime: null,
                endTime: null,
            },
            actionList: [
                { value: 1, label: '增加' },
                { value: 2, label: '减少' },
                { value: 3, label: '重置' }
            ],
            channelList: [],
            playerPoolInfoLogList: [],
            total: 0,
            page: 1,
            limit: 20,
            resetDialogVisible: false,
            updateDialogVisible: false,
            resetForm: {
                rid: null
            },
            updateForm: {
                rid: null,
                action: 1,
                num: null
            },
            resetRules: {
                'rid': [{ required: true, message: '请输入用户ID', trigger: 'blur' }]
            },
            updateRules: {
                'rid': [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
                'action': [{ required: true, message: '请选择变动类型', trigger: 'change' }],
                'num': [{ required: true, message: '请输入变动数值', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.getChannelList()
        this.initTimeRange()
        this.getPlayerPoolInfoLogList(1)
    },
    methods: {
        formatTime(row, column, cellValue) {
            return cellValue ? new Date(cellValue * 1000).toLocaleString() : ''
        },
        getActionText(action) {
            const actionMap = {
                1: '增加',
                2: '减少',
                3: '重置'
            }
            return actionMap[action] || '未知'
        },
        getActionTagType(action) {
            const typeMap = {
                1: 'success',
                2: 'danger',
                3: 'warning'
            }
            return typeMap[action] || 'info'
        },
        initTimeRange() {
            const now = new Date()
            const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
            
            // 保持毫秒时间戳用于日期选择器显示
            this.searchList.startTime = startOfDay.getTime()
            this.searchList.endTime = endOfDay.getTime()
        },
        async getChannelList() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.channelList +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.channelList = [
                    { channelId: -1, name: 'all', value: 'all' },
                    ...res.data,
                ]
            }
        },
        showResetDialog() {
            this.resetForm.rid = null
            this.resetDialogVisible = true
        },
        showUpdateDialog() {
            this.updateForm.rid = null
            this.updateForm.action = 1
            this.updateForm.num = null
            this.updateDialogVisible = true
        },
        handleCurrentChange(page) {
            this.getPlayerPoolInfoLogList(page)
        },
        handleStartTimeChange(value) {
            // 保持毫秒时间戳用于显示
            this.searchList.startTime = value
        },
        handleEndTimeChange(value) {
            // 保持毫秒时间戳用于显示
            this.searchList.endTime = value
        },
        async getPlayerPoolInfoLogList(page) {
            if (page) {
                this.page = page
            }
            
            const params = {
                username: this.$store.getters.username,
                token: this.$store.getters.token,
                eventCode: 9,
                pageNum: this.page,
                pageSize: this.limit,
                startTime: Math.floor(this.searchList.startTime / 1000),
                endTime: Math.floor(this.searchList.endTime / 1000)
            }
            
            if (this.searchList.rid) {
                params.rid = this.searchList.rid
            }
            if (this.searchList.action) {
                params.action = this.searchList.action
            }
            
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.pool_mgr_player_pool_info_log_list,
                params
            })
            
            if (res.code === 0 || res.status === 0) {
                console.log('API返回数据:', res.data)
                if (res.data && Array.isArray(res.data.data)) {
                    this.playerPoolInfoLogList = res.data.data
                    this.total = res.data.total || res.data.data.length
                } else {
                    this.playerPoolInfoLogList = []
                    this.total = 0
                }
                console.log('处理后的个人奖池信息日志列表:', this.playerPoolInfoLogList)
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async resetPlayerPool() {
            this.$refs.resetForm.validate(async (valid) => {
                if (valid) {
                    const { data: res } = await this.$axios({
                        method: 'get',
                        url: this.$store.getters.path.pool_mgr_player_pool_info_reset,
                        params: {
                            username: this.$store.getters.username,
                            token: this.$store.getters.token,
                            eventCode: 9,
                            rid: parseInt(this.resetForm.rid)
                        }
                    })
                    
                    if (res.code === 0 || res.status === 0) {
                        this.$message.success('重置成功')
                        this.resetDialogVisible = false
                        this.getPlayerPoolInfoLogList()
                    } else {
                        this.$message.error(res.msg || res.message)
                    }
                }
            })
        },
        async updatePlayerPool() {
            this.$refs.updateForm.validate(async (valid) => {
                if (valid) {
                    const { data: res } = await this.$axios({
                        method: 'get',
                        url: this.$store.getters.path.pool_mgr_player_pool_info_update,
                        params: {
                            username: this.$store.getters.username,
                            token: this.$store.getters.token,
                            eventCode: 9,
                            rid: parseInt(this.updateForm.rid),
                            action: parseInt(this.updateForm.action),
                            num: parseInt(this.updateForm.num)
                        }
                    })
                    
                    if (res.code === 0 || res.status === 0) {
                        this.$message.success('更新成功')
                        this.updateDialogVisible = false
                        this.getPlayerPoolInfoLogList()
                    } else {
                        this.$message.error(res.msg || res.message)
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.player-pool {
    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }
    }
}
</style>
